module.exports = __webpack_public_path__ + "img/logo-black.de246847.svg";